import { IGameState } from 'State/Game/IGameState';

export function isPayer(state: IGameState): boolean {
    return state.playerState.purchases > 0;
}